<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <div class="pt-2 pb-4">
    <div class="d-flex flex-column mb-2">
      <!-- Withdrawal -->
      <div class="d-flex flex-column mb-2">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Retiro:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ parseDate(item.form.dateStar) | date: "EEE. dd MMM yyyy" }}
        </span>

        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{item.form.hourOrigin}} hs
        </span>
      </div>


      <!-- Location -->
      <div class="d-flex flex-column mb-2" style="gap: 5px">
        <div class="d-flex align-items-center" style="gap: 2px;">
          <img width="20" height="20" src="../../../../../../assets/icons/cart/locación.svg" />

          <span
            style="
              font-size: 12px;
              font-weight: 600;
              font-family: 'Rubik';
              line-height: 1;
              text-transform: none;
            "
          >Ver mapa</span>
        </div>

        <p
          class="m-0"
          style="
            font-size: 12px;
            font-weight: 400;
            line-height: 1;
            font-family: 'Rubik';
            color: #747474;
            text-transform: none;
          "
        >
          {{item?.pickupSelected?.name}}
        </p>
      </div>


    </div>

    <div class="d-flex flex-column mb-2">
      <!-- Return -->
      <div class="d-flex flex-column mb-2">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Devolución:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 600;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ parseDate(item.form.dateEnd) | date: "EEE. dd MMM yyyy" }}
        </span>

        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{item.form.hourDestination}} hs
        </span>
      </div>


      <!-- Location -->
      <div class="d-flex flex-column mb-2" style="gap: 5px">
        <div class="d-flex align-items-center" style="gap: 2px;">
          <img width="20" height="20" src="../../../../../../assets/icons/cart/locación.svg" />

          <span
            style="
              font-size: 12px;
              font-weight: 600;
              font-family: 'Rubik';
              line-height: 1;
              text-transform: none;
            "
          >Ver mapa</span>
        </div>

        <p
          class="p-0"
          style="
            font-size: 12px;
            font-weight: 400;
            line-height: 1;
            font-family: 'Rubik';
            color: #747474;
            text-transform: none;
          "
        >
          {{item?.dropoffSelected?.name}}
        </p>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6" style="border-right: 2px solid #000000;">
        <div class="d-flex align-items-center" style="gap: 15px;">
          <div class="d-flex align-items-center">
            <img class="mr-1" width="18" height="18" src="../../../../../../assets/icons/itinerary/persona.svg"/>
            <span
              style="
                font-size: 13px;
                font-weight: 600;
                font-family: 'Rubik';
                text-transform: none;
              "
            >
              {{ item.paxQuantity }}
            </span>
          </div>
          <div class="d-flex align-items-center">
            <img class="mr-1" width="18" height="18" src="../../../../../../assets/icons/search-result/puerta de auto.svg"/>
            <span
              style="
                font-size: 13px;
                font-weight: 600;
                font-family: 'Rubik';
                text-transform: none;
              "
            >
              {{ item?.doors }}
            </span>
          </div>
          <div class="d-flex align-items-center">
            <img class="mr-1" width="18" height="18" src="../../../../../../assets/icons/cart/MALETA 1.svg"/>
            <span
              style="
                font-size: 13px;
                font-weight: 600;
                font-family: 'Rubik';
                text-transform: none;
              "
            >
              {{ item?.bagsQuantity || "N/A" }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="d-flex align-items-center" style="gap: 15px;">
          <img *ngIf="item.fuel_aircondition === 'Con Aire Acondicionado'" width="18" height="18" src="../../../../../../assets/icons/search-result/aire acondicionado 02.svg" />

          <div class="d-flx align-items-center">
            <img width="18" height="18" src="../../../../../../assets/icons/search-result/caja automática 02.svg" />

            <span
              style="
                font-size: 13px;
                font-family: 'Rubik';
                color: #2c2c2c;
                font-weight: 500;
                text-transform: none;
              "
            >
              {{item.gearbox}}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <span
        style="
          font-size: 13px;
          font-family: 'Rubik';
          color: #2c2c2c;
          font-weight: 500;
          text-transform: none;
          line-height: 1.2;
        "
      >
        Adicionales
      </span>
      <ul
        style="
          list-style: none;
          margin: 0;
          padding: 0;
        "
      >
        <ng-container *ngIf="item?.addonsIncluded?.length === 0">
          <li>
            <span
              style="
                font-size: 13px;
                font-family: 'Rubik';
                color: #2c2c2c;
                font-weight: 400;
                text-transform: none;
                line-height: 1.2;
              "
            >
              Sin adicionales
            </span>
          </li>
        </ng-container>

        <ng-container *ngFor="let addon of item.addonsIncluded">
          <li>
            <span
              style="
                font-size: 13px;
                font-family: 'Rubik';
                color: #2c2c2c;
                font-weight: 400;
                text-transform: none;
                line-height: 1.2;
              "
            >
              <img class="mr-1" width="10" height="10" src="../../../../../../assets/img/app/little-icons/check.svg" />
              {{ addon.Name }}
            </span>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</usb-base-item>
